// useBrowserInfo.ts
import { useMemo } from "react"
import { Platform } from "react-native"

interface BrowserInfo {
  isFacebookBrowser: boolean
  isInstagramBrowser: boolean
  isTwitterBrowser: boolean
  isTikTokBrowser: boolean
  isSafari: boolean
  isChrome: boolean
  isMobile: boolean
  isEmbeddedBrowser: boolean
  userAgent: string
}

const useBrowserInfo = (): BrowserInfo => {
  return useMemo(() => {
    if (Platform.OS === "web") {
      const navigatorInfo = navigator
      const userAgent: string =
        navigatorInfo.userAgent ||
        navigatorInfo.vendor ||
        (window as any).opera ||
        ""

      // Check if running inside Facebook App Browser
      const isFacebookBrowser: boolean = /FBAN|FBAV|FB_IAB|FB4A/i.test(
        userAgent
      )

      // Check if running inside Instagram App Browser
      const isInstagramBrowser: boolean = /Instagram/i.test(userAgent)

      // Check if running inside Twitter App Browser
      const isTwitterBrowser: boolean = /Twitter/i.test(userAgent)

      // Check if running inside TikTok App Browser
      const isTikTokBrowser: boolean = /TikTok/i.test(userAgent)

      // Check if the browser is Safari
      const isSafari: boolean = /^((?!chrome|android).)*safari/i.test(userAgent)

      // Check if the browser is Chrome
      const isChrome: boolean = /Chrome|CriOS/i.test(userAgent)

      // Check if the device is mobile
      const isMobile: boolean = /Mobi|Android/i.test(userAgent)

      // Check all Embedded Browsers
      const isEmbeddedBrowser: boolean =
        isFacebookBrowser ||
        isInstagramBrowser ||
        isTwitterBrowser ||
        isTikTokBrowser

      return {
        isFacebookBrowser,
        isInstagramBrowser,
        isTwitterBrowser,
        isTikTokBrowser,
        isSafari,
        isChrome,
        isMobile,
        isEmbeddedBrowser,
        userAgent,
      }
    }

    // Default values for non-web platforms
    return {
      isFacebookBrowser: false,
      isInstagramBrowser: false,
      isTwitterBrowser: false,
      isTikTokBrowser: false,
      isSafari: false,
      isChrome: false,
      isMobile: false,
      isEmbeddedBrowser: false,
      userAgent: "",
    }
  }, [])
}

export default useBrowserInfo
